"use client";

import { createContext, useContext, useMemo, useState } from "react";
import useEnvVariables from "@/libs/shared/hooks/useEnvVariables";

const SignupContext = createContext<any>({});

const SignupProvider = ({ children }: any) => {
  const env = useEnvVariables();
  const [signupForm, setSignupForm] = useState({});

  const context = useMemo(
    () => ({
      googleMapsKey: env?.GOOGLE_MAPS_KEY,
      signupForm,
      setSignupForm,
    }),
    [signupForm, setSignupForm, env],
  );

  return (
    <SignupContext.Provider value={context}>
      {env && children}
    </SignupContext.Provider>
  );
};

export const useSignupContext = () => useContext(SignupContext);

export default SignupProvider;
